import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled
} from '@mui/material';
import { routes } from 'common/constants';
import { useHistory } from 'react-router-dom';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import BarChartIcon from '@mui/icons-material/BarChart';
import SavingsIcon from '@mui/icons-material/Savings';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

const MenuItem = styled(ListItem)(({ theme }) => ({
  background: '#fff',
  borderRadius: '1rem',
  marginBottom: '0.5rem',
  overflow: 'hidden',
  '&:hover': {
    background: '#fefaf4'
  }
}));

const MainNavigation = () => {
  const history = useHistory();
  return (
    <>
      <Box sx={{ pt: '20px' }} />
      <List component="nav">
        <MenuItem key="Expenses" disablePadding>
          <ListItemButton onClick={() => history.push(routes.home)}>
            <ListItemIcon>
              <AccountBalanceWalletIcon />
            </ListItemIcon>
            <ListItemText primary="Expenses" />
          </ListItemButton>
        </MenuItem>
        <MenuItem key="MonthBudget" disablePadding>
          <ListItemButton onClick={() => history.push(routes.budgetMonth)}>
            <ListItemIcon>
              <BarChartIcon />
            </ListItemIcon>
            <ListItemText primary="Month Budget" />
          </ListItemButton>
        </MenuItem>
        <MenuItem key="Budgets" disablePadding>
          <ListItemButton onClick={() => history.push(routes.budgets)}>
            <ListItemIcon>
              <SavingsIcon />
            </ListItemIcon>
            <ListItemText primary="Budgets" />
          </ListItemButton>
        </MenuItem>
        <MenuItem key="Incomes" disablePadding>
          <ListItemButton onClick={() => history.push(routes.incomes)}>
            <ListItemIcon>
              <MonetizationOnIcon />
            </ListItemIcon>
            <ListItemText primary="Incomes" />
          </ListItemButton>
        </MenuItem>
      </List>
    </>
  );
};

export default MainNavigation;
